<div class="validation-project-resume-table-container">
  @if (model) {
    <div class="validation-project-resume-table-header">
      @if (model.withInstallation) {
        <div
          class="validation-title blue"
          [innerHtml]="'validation.project-resume.with-installation' | translate"></div>
      } @else {
        <div
          class="validation-title blue"
          [innerHtml]="'validation.project-resume.without-installation' | translate"></div>
      }
      <div
        class="total-price"
        [innerHtml]="
          pricing.prixTotal.discountPrices[tunnelService.kitchenTunnelData?.discountValue].amount
            | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
        "></div>
    </div>
    <div class="validation-project-resume-table-data">
      <div class="table-data-row">
        <div class="table-data-line" id="kitchen-without-appliance">
          <div
            class="table-data-label"
            [innerHtml]="'validation.project-resume.kitchen-without-appliance' | translate"></div>
          <div class="table-data-price">
            @if (discountApplied) {
              <div
                class="table-data-discount-value"
                [innerHtml]="
                  pricing?.prixProduitsHorsElectromenager.amount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                "></div>
            }
            <div
              class="table-data-value"
              [innerHtml]="
                pricing?.prixProduitsHorsElectromenager.discountPrices[tunnelService.kitchenTunnelData?.discountValue]
                  .amount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
              "
              [ngClass]="{ 'text-danger': discountApplied }"></div>
          </div>
        </div>
        <div class="table-data-line" id="kitchen-with-appliance">
          <div
            class="table-data-label"
            [innerHtml]="'validation.project-resume.kitchen-with-appliance' | translate"></div>
          <div class="table-data-price">
            @if (discountApplied) {
              <div
                class="table-data-discount-value"
                [innerHtml]="
                  pricing?.prixProduitsElectromenager.amount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                "></div>
            }
            <div
              class="table-data-value"
              [innerHtml]="
                pricing?.prixProduitsElectromenager.discountPrices[tunnelService.kitchenTunnelData?.discountValue]
                  .amount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
              "
              [ngClass]="{ 'text-danger': discountApplied }"></div>
          </div>
        </div>
        @if (isWorkbench) {
          <div class="table-data-line" id="workbench">
            <div class="table-data-label" [innerHtml]="'validation.project-resume.workbench' | translate"></div>
            <div class="table-data-price">
              @if (discountApplied) {
                <div
                  class="table-data-discount-value"
                  [innerHtml]="
                    model.workbenchInstallation.totalPrixPlanWorkbench.amount
                      | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                  "></div>
              }
              <div
                class="table-data-value"
                [innerHtml]="
                  model.workbenchInstallation.totalPrixPlanWorkbench.discountPrices[
                    tunnelService.kitchenTunnelData?.discountValue
                  ].amount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                "
                [ngClass]="{ 'text-danger': discountApplied }"></div>
            </div>
          </div>
          @if (model.workbenchInstallation.totalPrixPackagesPricesWorkbench.amount > 0) {
            <div class="table-data-line" id="workbench-packages">
              <div
                class="table-data-label"
                [innerHtml]="'validation.project-resume.workbench-packages' | translate"></div>
              <div class="table-data-price">
                <div
                  class="table-data-value"
                  [innerHtml]="
                    model.workbenchInstallation.totalPrixPackagesPricesWorkbench.amount
                      | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                  "></div>
              </div>
            </div>
          }
        }
      </div>
      <div class="table-data-row">
        <div class="table-data-line" id="delivery">
          <div class="table-data-label" [innerHtml]="'validation.project-resume.delivery' | translate"></div>
          <div class="table-data-price">
            <div
              class="table-data-value sub-total-price"
              [innerHtml]="
                pricing?.prixLivraison.discountPrices[tunnelService.kitchenTunnelData?.discountValue].amount
                  | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
              "></div>
          </div>
        </div>
      </div>
      @if (model.withInstallation) {
        <div class="table-data-row">
          <div class="table-data-line" id="installation">
            <div class="label-container">
              <div class="table-data-label" [innerHtml]="'validation.project-resume.installation' | translate"></div>
              <div class="table-data-icon">
                <a href="javascript:" (click)="openInstallationDetail()">
                  <svg class="custom-icon">
                    <use xlink:href="assets/img/icons.svg#icon-info-circle"></use>
                  </svg>
                </a>
              </div>
            </div>

            <div class="table-data-price">
              <div
                class="table-data-value sub-total-price"
                [innerHtml]="pricing?.sousTotalPrixPose.amount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'"></div>
            </div>
          </div>
        </div>
      }
      <div class="table-data-row">
        <div class="table-data-line" id="funding">
          <div class="label-container">
            <div class="table-data-label" [innerHtml]="'validation.project-resume.base-funding' | translate"></div>
            <div class="table-data-icon">
              <a href="javascript:" (click)="openComparatifFinancement()">
                <svg class="custom-icon">
                  <use xlink:href="assets/img/icons.svg#icon-compare"></use>
                </svg>
              </a>
            </div>
          </div>

          <div class="table-data-price flex-column align-items-end">
            @if (model.mensuality && model.duration) {
              <div
                class="table-data-value sub-total-price"
                [innerHtml]="
                  'validation.project-resume.base-funding-value'
                    | translate
                      : {
                          value: model.mensuality | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr',
                          duration: model.duration,
                          interets: model.interest | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr',
                        }
                "></div>
            } @else {
              <p-skeleton width="20rem" styleClass="mb-2"/>
            }
            @if (model.downPayment > 0) {
              <p
                [innerHTML]="
                  'validation.project-resume.downPayment'
                    | translate
                      : {
                          value: model.downPayment | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr',
                        }
                "></p>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="validation-fidelity-advantage">
      <ng-fidelity-advantage [model$]="fidelityAdvantageValidation.asObservable()"></ng-fidelity-advantage>
    </div>
  } @else {
    <div class="validation-project-resume-table-header">
      @if (model.withInstallation) {
        <div
          class="validation-title blue"
          [innerHtml]="'validation.project-resume.with-installation' | translate"></div>
      } @else {
        <div
          class="validation-title blue"
          [innerHtml]="'validation.project-resume.without-installation' | translate"></div>
      }
    </div>
    <div class="validation-project-resume-table-data">
      <div class="table-data-row">
        <p-skeleton styleClass="p-2"/>
      </div>
      <div class="table-data-row">
        <p-skeleton styleClass="p-2"/>
      </div>
      @if (model.withInstallation) {
        <div class="table-data-row">
          <p-skeleton styleClass="p-2"/>
        </div>
      }
      <div class="table-data-row">
        <p-skeleton styleClass="p-2"/>
      </div>
    </div>
  }
</div>
